import React from 'react'
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox'
import MarkerWithLabel from 'react-google-maps/lib/components/addons/MarkerWithLabel'
import commaNumber from 'comma-number'
import StringHelper from '../../common/helpers/string_helper'
import { ratingClassification } from "../../common/constants/classifications"
import './map.scss'
import CurrencyHelper from '../../common/helpers/currency_helper'
import getSymbolFromCurrency from 'currency-symbol-map'
import { Trans } from "react-i18next"

/* global google */

export default class extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hover: false
    }
  }

  get lang() {
    return (
      this.props.lang ||
      document.querySelector('meta[name="language-locale"]').content
    )
  }

  imageStyle = url => {
    return {
      backgroundImage: `url(${url})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }
  }

  getPositionForProperty(property) {
    const lat = parseFloat(property.lat)
    const lng = parseFloat(property.lon)
    return { lat, lng }
  }

  getPositionForRoomGroup(roomGroup) {
    return this.getPositionForProperty(roomGroup.property)
  }

  renderRating() {
    const { review_stats: reviewStats } = this.props.roomGroup
    const { t } = this.props
    if (reviewStats) {
      const { overall_stats: { count, avg } } = reviewStats
      const averageRating = avg.toFixed(1)
      const cls = ratingClassification(averageRating)
        .toLowerCase().replace(/ /g, "-").replace(/[^\w-]/, "")
      return (
        <div
          styleName={`review-stats review-stats-${cls || "default"}`}
          itemProp="aggregateRating"
          itemScope
          itemType="http://schema.org/AggregateRating"
        >
          <meta itemProp="worstRating" content="1" />
          <div styleName="cols">
            <div styleName="rating">
              <div>
                <span styleName="rating-value" itemProp="ratingValue">
                  {averageRating}
                </span>
                <span styleName="best-rating" itemProp="bestRating">/5</span>
              </div>
            </div>
            <div styleName="summary">
              <div styleName="label">{ratingClassification(averageRating)}</div>
              <div styleName="count">
                <span itemProp="reviewCount" className="notranslate">
                  {count}
                </span>
                {t('search.listing_item.reviews')}
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  renderPrice() {
    const { checkin, checkout, roomGroup: { min_price: minPrice, max_price: maxPrice, accommodation_fee }, t } = this.props

    if (this.props.checkin && this.props.checkout) {
      return (
        <div>
          <p>
            <span styleName="price-unit">{getSymbolFromCurrency(CurrencyHelper.metaCurrencyCode())}</span>
            <span styleName="price">{commaNumber(accommodation_fee)}</span>
          </p>
        </div>
      )
    } else {
      return (
        <div>
          <p>
            <span styleName="price-unit">{getSymbolFromCurrency(CurrencyHelper.metaCurrencyCode())}</span>
            <span styleName="price">{commaNumber(minPrice)}</span>
          </p>
          <p styleName="price-per-person">
            <span className='notranslate'>
              ~ {getSymbolFromCurrency(CurrencyHelper.metaCurrencyCode())}{commaNumber(maxPrice)}
            </span>
            <span styleName="price-unit">/{t('search.listing_item.per_night')}</span>
          </p>
        </div>
      )
    }
  }

  renderNoPrice() {
    const { t } = this.props
    return (
      <div>
        <p styleName='no-price'>
          {t('search.price_range.no_valid_pricing')}
        </p>
      </div>
    )
  }

  infoBox() {
    const { index, roomGroup, propertyType, checkin, checkout, rooms, adults, t } = this.props
    const listingQueryOptions = { checkin, checkout, rooms, adults }
    const position = this.getPositionForRoomGroup(roomGroup)
    const hasPrice = roomGroup.min_price || roomGroup.max_price

    const infoBoxOptions = {
      closeBoxURL: ``,
      enableEventPropagation: false,
      alignBottom: true,
      maxWidth: 0,
      pixelOffset: new google.maps.Size(-176, -13),
      boxStyle: {
        width: '350px',
        overflow: 'visible'
      },
      visible: true,
      position: new google.maps.LatLng(position.lat, position.lng)
    }

    return (
      <InfoBox
        key={index}
        onCloseClick={this.onToggleMarker}
        options={infoBoxOptions}
      >
        <a
          styleName="info-box-inner"
          href={routeUrlHelper.listingPath(roomGroup.id, listingQueryOptions)}
          target="_blank"
        >
          <div styleName="thumb" style={this.imageStyle(roomGroup.photos[0])} />
          <div styleName="detail">
            <div>
              <div styleName="property-type">{propertyType}</div>
              <div styleName="title-wrapper">
                <div styleName="title">
                  {StringHelper.getPreferredLanguageString(
                    roomGroup.room_title,
                    this.lang
                  )}
                </div>
              </div>
              {this.renderRating()}
            </div>
            <div>
              <div styleName="deal">
                <div styleName="price-wrapper">
                  {hasPrice
                    ? this.renderPrice()
                    : this.renderNoPrice()
                  }
                </div>
                {roomGroup.is_instant_booking && (
                  <div styleName="instant-booking-mark">
                    <span
                      styleName="icon"
                      className="vs-icon-lightning-bolt-fill"
                    />
                    <span>{t('search.listing_item.instant_booking')}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </a>
      </InfoBox>
    )
  }

  infoBoxMini() {
    const { roomGroup } = this.props

    return (
      <MarkerWithLabel
        key={roomGroup.id}
        opacity={0}
        position={this.getPositionForRoomGroup(roomGroup)}
        labelAnchor={new google.maps.Point(22, 50)}
        onClick={() => {
          this.props.onClick(roomGroup)
          this.setState({ hover: false })
        }}
        onMouseOver={() => this.setState({ hover: true })}
        onMouseOut={() => this.setState({ hover: false })}
      >
        <div
          styleName={`info-box-mini-inner ${
            roomGroup.id == this.props.hoveredRoomGroupId ? 'highlight' : ''
          }`}
        >
          <img src={`/assets/image/search/map/map-marker${this.state.hover ? '-fill' : ''}.png`} />
        </div>
      </MarkerWithLabel>
    )
  }

  render() {
    const { highlightedRoomGroup, roomGroup } = this.props
    const isHighlightedRoomGroup = highlightedRoomGroup && highlightedRoomGroup.id == roomGroup.id
    return isHighlightedRoomGroup ? this.infoBox() : this.infoBoxMini()
  }
}
